import { dispatcher, ingenuity } from "@quest/base-core";
import { Wrapper } from "@quest/platform-murka/dist";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { GameParserModel } from "./GameParserModel";
import { EventConstantsLeander } from "@quest/oddsworks-platform";

export class WrapperController extends Wrapper {
  /**
   * overrided to parse data for freespins
   */
  protected onRequestCompleted(evt: any): void {
    super.onRequestCompleted(evt);
    if ((ingenuity.parserModel as GameParserModel).getSelectionScreenAvailable()) {
      evt.data[0].method == "placeBet" &&
        evt.data[1].method == "getBetResult" &&
        dispatcher.fireEvent(eventDispatchers.PARSE_FREE_GAME_RESPONSE_AFTER_REQUEST, evt.data[1]);
    }
  }

  protected handleRequestError(event: any): void {
    let errorCode = event.code;
    if (event.type !== "requestFailed" && (errorCode == "509" || errorCode == "509b")) {
      (ingenuity.parserModel as GameParserModel).setIsOutOfBalance(true);
    }
    if (event.type === "requestFailed") {
      goldenspinGMApi.publishEvent(goldenspinGMApi.publications.ERROR_OCCURRED, {
        data: 99,
        error: {
          code: 99,
          message: "NETWORK ERROR PLEASE REFRESH",
        },
      });
      dispatcher.fireEvent(EventConstantsLeander.PAUSE_GAME_ON_NETWORK_ERROR);
    } else {
      let errorCode = event.code;
      if (event.code == undefined) {
        for (var i = 0; i < event.data.length; i++) {
          if (event.data[i].status == "ERROR" || event.data[i].status == "SERVER_ERROR") {
            errorCode = event.data[i].code;
          }
        }
      }
      if (
        errorCode == "99" ||
        errorCode == "101" ||
        errorCode == "102" ||
        errorCode == "103" ||
        errorCode == "104" ||
        errorCode == "105" ||
        errorCode == "106" ||
        errorCode == "107" ||
        errorCode == "108" ||
        errorCode == "110" ||
        errorCode == "111" ||
        errorCode == "112" ||
        errorCode == "113" ||
        errorCode == "114" ||
        errorCode == "116" ||
        errorCode == "536" ||
        errorCode == "201" ||
        errorCode == "202"
      ) {
        //
        goldenspinGMApi.publishEvent(goldenspinGMApi.publications.ERROR_OCCURRED, { data: errorCode, error: event });
      } else if (errorCode == "530" || errorCode == "531" || errorCode == "532" || errorCode == "533") {
        this.errorOnBet = false;
        dispatcher.fireEvent(EventConstantsLeander.HANDLE_GAME_AFTER_ERROR);
        goldenspinGMApi.publishEvent(goldenspinGMApi.publications.ERROR_OCCURRED, { data: errorCode, error: event });
      } else if (errorCode == "509" || errorCode == "509b") {
        this.errorOnBet = false;
        dispatcher.fireEvent(EventConstantsLeander.HANDLE_GAME_AFTER_ERROR);
        !ingenuity.configData.isBSPOTEnable &&
          goldenspinGMApi.publishEvent(goldenspinGMApi.publications.ERROR_OCCURRED, { data: errorCode, error: event });
      }
    }
    if (event.code != 999 || event.code != "999") {
      // errorcode 999 is for broken game
      goldenspinGMApi.publishEvent(goldenspinGMApi.publications.GAME_STATUS_CHANGED, goldenspinGMApi.gameStates.SETTLE_PLAY);
    }
  }

  protected setLanguage(): void {
    this.languageSupported = ['es', 'fr-ca', 'en', 'bs'];
    let language = "";
    (ingenuity.parserModel as GameParserModel).setLanguage(null);
    let currentLang = goldenspinGMApi.gameOptions.userLocale;
    if (currentLang === "fr_ca") {
      currentLang = "fr-ca";
    } else {
      currentLang = currentLang.split("_")[0];
    }
    if (goldenspinGMApi.gameOptions.locale === "bs") {
      currentLang = goldenspinGMApi.gameOptions.locale;
    }
    if (currentLang !== undefined) {
      if (currentLang.indexOf("_") !== -1) {
        currentLang = currentLang.split("_")[0];
      }
      for (let lang of this.languageSupported) {
        if (lang === currentLang) {
          (ingenuity.parserModel as GameParserModel).setLanguage(currentLang);
          language = currentLang;
        }
      }
    }
    if (!language) {
      (ingenuity.parserModel as GameParserModel).setLanguage(this.defaultLang);
    }
    ingenuity.lang = (ingenuity.parserModel as GameParserModel).getLanguage();
  }

  // protected onApiInitialization(): void {
  //   this.updateBaseURL();
  //   this.defaultLang = "en";
  //   this.languageSupported = ["es", "fr-ca", "en", "bs"];
  //   this.model = ingenuity.parserModel;
  //   this.parseGameOptions();
  //   super.onApiInitialization();
  //   this.setLanguage();
  // }
}
